import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Option = (props) => {
  const {
    disabled = false,
    selected = false,
    title,
    subTitle,
    description,
    onSelectOption,
    index,
    imageUrl
  } = props;

  const onSelect = () => onSelectOption(index);

  return (
    <div
      onClick={onSelect}
      onKeyDown={(e) => e.key === 'Enter' && onSelect()}
      role="button"
      tabIndex={0}
      className={classNames('option mb-3', {
        'selected': selected,
        'disabled': disabled
      })}
    >
      <span className="icon radio" />
      <div className="content position-relative">
        <div className="d-flex flex-row justify-content-between">
          <div>
            <h6 className="title my-0">{title}</h6>
            <h6 className="subtitle">{subTitle}</h6>
          </div>
          {imageUrl && (
            <img src={imageUrl} alt="Option" />
          )}
        </div>
        {description && (
          <p className="description">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

Option.propTypes = {
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  subTitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  onSelectOption: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  imageUrl: PropTypes.string,
};

Option.defaultProps = {
  disabled: false,
  selected: false,
  description: '',
  subTitle: '',
  imageUrl: null,
};

export default Option;